import React, { useState, useEffect } from 'react'
import { Empty, message, Popconfirm, Table, Tooltip } from 'antd'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUnlink } from '@fortawesome/free-solid-svg-icons'

import ModelStoreForm from './ModelStoreForm'
import { deleteModelStore, getModelStores } from '../services'
import { handleError } from '../../../helpers'

export default function ModelStoresModal({ visible, onClose, type, id }) {
	const [modelStores, setModelStores] = useState(null)

	useEffect(() => {
		!modelStores && visible && getModelStores({
			'filter[model_type]': type,
			'filter[model_id]': id
		})
			.then(res => setModelStores(res.data.data))
			.catch(error => handleError(error))
	}, [ modelStores, type, id, visible ])

	const handleDelete = id => {
		deleteModelStore(id)
			.then(() => {
				message.success('Tienda desasociada exitosamente')
				setModelStores(null)
			})
			.catch(error => handleError(error))
	}

	const columns = [
		{
			title: 'Nombre de Tienda',
			dataIndex: 'store_name'
		},
		{
			title: 'Acciones',
			render: (t, record) => (
				<React.Fragment>
					<Popconfirm
						title="¿Segura desea desasociar la tienda?"
						okText="Desasociar"
						cancelText="Cancelar"
						onConfirm={() => handleDelete(record.id)}
						okButtonProps={{ danger: true }}
					>
						<Tooltip title="Desasociar">
							<FontAwesomeIcon 
								className="text-link"
								icon={faUnlink}
							/>
						</Tooltip>
					</Popconfirm>
				</React.Fragment>
			)
		}
	]

	const handleClose = () => {
		onClose()
		setModelStores(null)
	}

	return (
		<Modal isOpen={visible} toggle={handleClose}>
			<ModalHeader toggle={handleClose}>Tiendas Asociadas</ModalHeader>
			<ModalBody>
				<Table 
					dataSource={modelStores}
					rowKey={record => record.id}
					columns={columns}
					size="small"
					locale={{ emptyText: <Empty description='No tiene tiendas asociadas' imageStyle={{ height: 60 }} /> }}
					loading={!modelStores}
				/>
				<ModelStoreForm 
					id={id}
					type={type}
					reload={() => setModelStores(null)}
				/>
			</ModalBody>
		</Modal>
	)
}